import { render } from "./ServiceInvoiceCreateView.vue?vue&type=template&id=2cd319a2"
import script from "./ServiceInvoiceCreateView.vue?vue&type=script&lang=js"
export * from "./ServiceInvoiceCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__